import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import UpdateAnimationRequest from '../../../Spirit/Admin/Interfaces/Models/AnimationService/UpdateAnimationRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import AnimationResponse from '../../../Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse';
import AppSettings from '@/appSettings';

export default class AnimationService {
	webApiService: WebApiService;
	DeleteAnimationEvent = new Events<WsResponseModelT<Boolean>>();
	GetAnimationsEvent = new Events<WsResponseModelT<Array<AnimationResponse>>>();
	UpdateAnimationEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('AnimationService', 'DeleteAnimation', (res: WsResponseModelT<Boolean>) => {
			self.DeleteAnimationEvent.trigger(res);
		});
		webApiService.on('AnimationService', 'GetAnimations', (res: WsResponseModelT<Array<AnimationResponse>>) => {
			self.GetAnimationsEvent.trigger(res);
		});
		webApiService.on('AnimationService', 'UpdateAnimation', (res: WsResponseModelT<Boolean>) => {
			self.UpdateAnimationEvent.trigger(res);
		});
	}
	DeleteAnimation(id: string = '') { 	
        this.webApiService.send('AnimationService', 'DeleteAnimation' , id);
    }
	GetAnimations() { 	
        this.webApiService.send('AnimationService', 'GetAnimations' );
    }
	UpdateAnimation(request: UpdateAnimationRequest = null) { 	
        this.webApiService.send('AnimationService', 'UpdateAnimation' , request);
    }
	 // async methods
	async deleteAnimationAsync(id: string = ''): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.DeleteAnimation.bind(this), this.DeleteAnimationEvent)(id);
	}
	async getAnimationsAsync(): Promise<Array<AnimationResponse>> {
		const response = await EventToAsyncDecorator.getInstance().bind(this.GetAnimations.bind(this), this.GetAnimationsEvent)();
		return (response || []).map((item) => this.normalizeAnimation(item));
	}
	async updateAnimationAsync(request: UpdateAnimationRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateAnimation.bind(this), this.UpdateAnimationEvent)(request);
	}

	private normalizeAnimation(item: AnimationResponse): AnimationResponse {
		if (!item) {
			return item;
		}

		return new AnimationResponse({
			...item,
			Url: this.normalizeAnimationUrl(item.Url),
		});
	}

	private normalizeAnimationUrl(url?: string): string {
		if (!url) {
			return url;
		}

		const trimmedUrl = url.trim();
		if (!trimmedUrl) {
			return trimmedUrl;
		}

		if (/^https?:\/\//i.test(trimmedUrl) || /^blob:/i.test(trimmedUrl) || /^data:/i.test(trimmedUrl)) {
			return trimmedUrl;
		}

		if (trimmedUrl.startsWith('/files/')) {
			return `${AppSettings.filesBaseUrl}${trimmedUrl}`;
		}

		if (trimmedUrl.startsWith('files/')) {
			return `${AppSettings.filesBaseUrl}/${trimmedUrl}`;
		}

		if (trimmedUrl.startsWith('/')) {
			return `${AppSettings.filesBaseUrl}${trimmedUrl}`;
		}

		const lowerCasedUrl = trimmedUrl.toLowerCase();
		const looksLikeVideoFile = lowerCasedUrl.endsWith('.mp4') || lowerCasedUrl.endsWith('.webm') || lowerCasedUrl.endsWith('.mov');
		if (looksLikeVideoFile) {
			return `${AppSettings.filesBaseUrl}/files/Animations/${trimmedUrl}`;
		}

		return `${AppSettings.filesBaseUrl}/${trimmedUrl}`;
	}
}
